
const network = require( './network/network_api' );

export default function(
    $state,
    space,
)
{
    let isIn = false;
    
    //freespin:
    $state
        .filter( state => state.type == network.TYPE.FREEGAME )
        .subscribe( state =>
        {
            if ( ! isIn )
            {
                isIn = true;
                space.s( "freegames:start" ).next( state.state.stage.math );
            }
            
            space.s( "freegames:freespin" ).next( state );
        } );
    
    //non freespin:
    $state
        .filter( state => state.type != network.TYPE.FREEGAME )
        .subscribe( state => isIn = false );
}




// WEBPACK FOOTER //
// ./src/library/freegames.es6